import { currentUserIdSelector } from '../../Auth/selectors';
import { retrieveLoggedInUserTosAcceptanceDates } from '../../LoggedInUser/dispatchers';

export const loadCurrentUserTosAcceptanceDates = (dispatch, getState) => {
  const userId = currentUserIdSelector(getState());

  if (userId) {
    dispatch(
      retrieveLoggedInUserTosAcceptanceDates({
        userId,
      })
    );
  }
};
